import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastOptions = {
  position: "top-right",
  autoClose: 2000,
  closeOnClick: false,
  closeButton: true,
  pauseOnHover: true,
  draggable: true,
  progress: false,
  hideProgressBar: true,
  theme: "dark",
  // toastId: "Error",
};

class Toaster {
  success = (message) => {
    //@ts-ignore
    toast.success(message, {
      ...toastOptions,
    });
  };
  error = (message) => {
    //@ts-ignore
    toast.error(message, {
      ...toastOptions,
    });
  };
  warn = (message) => {
    //@ts-ignore
    toast.warn(message, {
      ...toastOptions,
    });
  };
  info = (message) => {
    //@ts-ignore

    toast.info(message, {
      ...toastOptions,
    });
  };
}
export const toasts = new Toaster();
